// extracted by mini-css-extract-plugin
module.exports = {"badgeUserCircle":"Board_badgeUserCircle__1S-6R","boardCard":"Board_boardCard__ZRN-O","bodyBoardCard":"Board_bodyBoardCard__26-vM","button":"Board_button__3flSt"};